// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.collection-browser {
  display: grid;
  grid-template-columns: 300px 1fr;
  gap: 24px;
  width: 100%;
}

.collections-sidebar {
  background: white;
  padding: 24px;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  height: fit-content;
  position: sticky;
  top: 20px;
}

.collections-sidebar h3 {
  margin: 0 0 20px 0;
  color: #1a1a1a;
  font-size: 18px;
  font-weight: 600;
  letter-spacing: -0.3px;
  padding-bottom: 12px;
  border-bottom: 2px solid #f0f0f0;
}

.collection-item {
  width: 100%;
  padding: 14px;
  margin-bottom: 12px;
  background: #fafafa;
  border: 1px solid #e8e8e8;
  border-radius: 8px;
  cursor: pointer;
  text-align: left;
  transition: all 0.2s ease;
}

.collection-item:hover {
  background: #f0f0f0;
  border-color: #d0d0d0;
  transform: translateX(2px);
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.06);
}

.collection-item.active {
  background: #1976d2;
  color: white;
  border-color: #1976d2;
  box-shadow: 0 2px 8px rgba(25, 118, 210, 0.3);
  transform: translateX(2px);
}

.collection-name {
  font-weight: 600;
  margin-bottom: 5px;
}

.collection-stats {
  font-size: 12px;
  display: flex;
  gap: 12px;
  margin-top: 6px;
  flex-wrap: wrap;
}

.collection-item.active .collection-stats {
  opacity: 0.9;
}

.documents-content {
  background: white;
  padding: 32px;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  min-height: 500px;
  display: flex;
  flex-direction: column;
}

.documents-content h3 {
  margin: 0 0 24px 0;
  color: #1a1a1a;
  font-size: 20px;
  font-weight: 600;
  letter-spacing: -0.3px;
}

.collection-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 28px;
  flex-wrap: wrap;
  gap: 16px;
  padding-bottom: 20px;
  border-bottom: 2px solid #f0f0f0;
  width: 100%;
}

.collection-header-actions {
  display: flex;
  align-items: center;
  gap: 16px;
  flex-wrap: wrap;
}

.collection-header h3 {
  flex: 1 1;
  min-width: 200px;
}

.collection-header-actions {
  display: flex;
  align-items: center;
  gap: 16px;
  flex-wrap: wrap;
}

.collection-details {
  display: flex;
  gap: 20px;
  font-size: 13px;
  color: #666;
  flex-wrap: wrap;
}

.collection-details span {
  padding: 6px 12px;
  background: #f8f9fa;
  border-radius: 6px;
  font-weight: 500;
  color: #495057;
}

.search-section {
  margin-bottom: 28px;
}

.search-box {
  display: flex;
  gap: 10px;
  align-items: center;
}

.search-box input {
  flex: 1 1;
  padding: 12px 16px;
  border: 2px solid #e0e0e0;
  border-radius: 8px;
  font-size: 14px;
  transition: all 0.2s ease;
}

.search-box input:focus {
  outline: none;
  border-color: #1976d2;
  box-shadow: 0 0 0 3px rgba(25, 118, 210, 0.1);
}

.search-button,
.clear-search-button,
.cancel-search-button {
  padding: 12px 24px;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  transition: all 0.2s ease;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.search-button {
  background: #1976d2;
  color: white;
}

.search-button:hover:not(:disabled) {
  background: #1565c0;
}

.search-button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.clear-search-button {
  background: #f5f5f5;
  color: #333;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.clear-search-button:hover {
  background: #e8e8e8;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15);
}

.cancel-search-button {
  background: #ff9800;
  color: white;
  box-shadow: 0 2px 4px rgba(255, 152, 0, 0.3);
  display: flex;
  align-items: center;
  gap: 8px;
}

.cancel-search-button:hover {
  background: #f57c00;
  box-shadow: 0 3px 6px rgba(255, 152, 0, 0.4);
  transform: translateY(-1px);
}

.cancel-search-button:active {
  transform: translateY(0);
}

.search-loading-spinner {
  width: 14px;
  height: 14px;
  border: 2px solid rgba(255, 255, 255, 0.3);
  border-top-color: white;
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

.search-results {
  margin-top: 20px;
  flex: 1 1;
}

.search-results h4 {
  margin: 0 0 20px 0;
  color: #1a1a1a;
  font-size: 18px;
  font-weight: 600;
  padding-bottom: 12px;
  border-bottom: 2px solid #f0f0f0;
}

.search-results-list {
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.search-result-item {
  padding: 18px;
  background: #fafafa;
  border-radius: 10px;
  border: 1px solid #e8e8e8;
  transition: all 0.2s ease;
}

.search-result-item:hover {
  background: #f5f5f5;
  border-color: #d0d0d0;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
}

.result-score {
  font-size: 12px;
  color: #666;
  margin-bottom: 8px;
  font-weight: 600;
}

.keyword-boost-indicator {
  color: #4caf50;
  font-weight: normal;
}

.result-text {
  font-size: 14px;
  color: #333;
  margin-bottom: 10px;
  line-height: 1.6;
}

.result-metadata {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}

.metadata-tag {
  padding: 4px 8px;
  background: #e3f2fd;
  color: #1976d2;
  border-radius: 12px;
  font-size: 11px;
}

.no-results {
  text-align: center;
  padding: 60px 40px;
  color: #999;
  background: #fafafa;
  border-radius: 10px;
  border: 2px dashed #e0e0e0;
  font-size: 15px;
}

.documents-list {
  display: flex;
  flex-direction: column;
  gap: 16px;
  flex: 1 1;
}

.document-item {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  padding: 20px;
  background: #fafafa;
  border-radius: 10px;
  border: 1px solid #e8e8e8;
  transition: all 0.2s ease;
}

.document-item:hover {
  background: #f5f5f5;
  border-color: #d0d0d0;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  transform: translateY(-1px);
}

.document-info {
  flex: 1 1;
}

.document-title {
  font-size: 17px;
  font-weight: 600;
  color: #1a1a1a;
  margin-bottom: 10px;
  line-height: 1.4;
}

.document-meta {
  display: flex;
  gap: 16px;
  font-size: 13px;
  color: #666;
  margin-bottom: 10px;
  flex-wrap: wrap;
}

.document-meta span {
  display: flex;
  align-items: center;
  gap: 4px;
}

.document-description {
  font-size: 14px;
  color: #666;
  margin-bottom: 8px;
}

.document-tags {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}

.tag {
  padding: 4px 8px;
  background: #1976d2;
  color: white;
  border-radius: 12px;
  font-size: 11px;
}

.document-actions {
  display: flex;
  gap: 10px;
  flex-shrink: 0;
  margin-left: 16px;
}

.preview-button {
  padding: 10px 18px;
  background: #1976d2;
  color: white;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  font-size: 13px;
  font-weight: 500;
  transition: all 0.2s ease;
  box-shadow: 0 2px 4px rgba(25, 118, 210, 0.2);
}

.preview-button:hover {
  background: #1565c0;
  box-shadow: 0 3px 6px rgba(25, 118, 210, 0.3);
  transform: translateY(-1px);
}

.delete-button {
  padding: 10px 18px;
  background: #f44336;
  color: white;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  font-size: 13px;
  font-weight: 500;
  transition: all 0.2s ease;
  box-shadow: 0 2px 4px rgba(244, 67, 54, 0.2);
}

.delete-button:hover {
  background: #d32f2f;
  box-shadow: 0 3px 6px rgba(244, 67, 54, 0.3);
  transform: translateY(-1px);
}


.preview-modal {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.preview-modal-content {
  background: white;
  padding: 0;
  border-radius: 12px;
  max-width: 900px;
  width: 90%;
  max-height: 90vh;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.2);
}

.preview-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 24px 30px;
  border-bottom: 2px solid #f0f0f0;
  background: #fafafa;
}

.preview-header h3 {
  margin: 0;
  color: #1a1a1a;
  font-size: 20px;
  font-weight: 600;
  letter-spacing: -0.3px;
}

.close-button {
  background: transparent;
  border: none;
  font-size: 28px;
  cursor: pointer;
  color: #666;
  line-height: 1;
  padding: 4px;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  transition: all 0.2s;
}

.close-button:hover {
  background: #f0f0f0;
  color: #333;
}

.preview-body {
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding: 30px;
  overflow-y: auto;
  flex: 1 1;
}

.preview-description,
.preview-tags {
  font-size: 14px;
  color: #666;
  padding: 12px;
  background: #f8f9fa;
  border-radius: 6px;
  border-left: 3px solid #1976d2;
}

.preview-text {
  margin-top: 10px;
}

.preview-text strong {
  display: block;
  margin-bottom: 12px;
  color: #1a1a1a;
  font-size: 15px;
  font-weight: 600;
}

.preview-text pre {
  background: #f8f9fa;
  padding: 20px;
  border-radius: 8px;
  overflow-x: auto;
  white-space: pre-wrap;
  word-wrap: break-word;
  max-height: 500px;
  overflow-y: auto;
  font-size: 13px;
  line-height: 1.7;
  border: 1px solid #e8e8e8;
  font-family: 'Consolas', 'Monaco', 'Courier New', monospace;
}

.preview-note {
  margin-top: 10px;
  font-size: 12px;
  color: #999;
  font-style: italic;
}

.loading,
.no-documents {
  text-align: center;
  padding: 60px 40px;
  color: #666;
  font-size: 15px;
  flex: 1 1;
  display: flex;
  align-items: center;
  justify-content: center;
}

.no-documents {
  background: #fafafa;
  border-radius: 10px;
  border: 2px dashed #e0e0e0;
  color: #999;
}

@media (max-width: 768px) {
  .collection-browser {
    grid-template-columns: 1fr;
  }
  
  .collections-sidebar {
    order: 2;
  }
  
  .documents-content {
    order: 1;
  }
  
  .collection-header {
    flex-direction: column;
    align-items: flex-start;
  }
}

`, "",{"version":3,"sources":["webpack://./src/admin/components/CollectionBrowser.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,gCAAgC;EAChC,SAAS;EACT,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,yCAAyC;EACzC,mBAAmB;EACnB,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,0BAA0B;EAC1B,yCAAyC;AAC3C;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,qBAAqB;EACrB,6CAA6C;EAC7C,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,SAAS;EACT,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,yCAAyC;EACzC,iBAAiB;EACjB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,SAAS;EACT,oBAAoB;EACpB,gCAAgC;EAChC,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,SAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;EACf,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;;;EAGE,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,wCAAwC;AAC1C;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,wCAAwC;AAC1C;;AAEA;EACE,mBAAmB;EACnB,yCAAyC;AAC3C;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,4CAA4C;EAC5C,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,mBAAmB;EACnB,4CAA4C;EAC5C,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,0CAA0C;EAC1C,uBAAuB;EACvB,kBAAkB;EAClB,oCAAoC;AACtC;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,gBAAgB;EAChB,SAAO;AACT;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,yCAAyC;AAC3C;;AAEA;EACE,eAAe;EACf,WAAW;EACX,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;EACX,mBAAmB;EACnB,mBAAmB;EACnB,0BAA0B;EAC1B,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,SAAO;AACT;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,yCAAyC;EACzC,2BAA2B;AAC7B;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;EACf,WAAW;EACX,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,6CAA6C;AAC/C;;AAEA;EACE,mBAAmB;EACnB,6CAA6C;EAC7C,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,4CAA4C;AAC9C;;AAEA;EACE,mBAAmB;EACnB,4CAA4C;EAC5C,2BAA2B;AAC7B;;;AAGA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,UAAU;EACV,mBAAmB;EACnB,gBAAgB;EAChB,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,WAAW;EACX,cAAc;EACd,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,aAAa;EACb,gBAAgB;EAChB,SAAO;AACT;;AAEA;;EAEE,eAAe;EACf,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;EACrB,qBAAqB;EACrB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,2DAA2D;AAC7D;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,WAAW;EACX,kBAAkB;AACpB;;AAEA;;EAEE,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,SAAO;EACP,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,0BAA0B;EAC1B,WAAW;AACb;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;AACF","sourcesContent":[".collection-browser {\n  display: grid;\n  grid-template-columns: 300px 1fr;\n  gap: 24px;\n  width: 100%;\n}\n\n.collections-sidebar {\n  background: white;\n  padding: 24px;\n  border-radius: 12px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);\n  height: fit-content;\n  position: sticky;\n  top: 20px;\n}\n\n.collections-sidebar h3 {\n  margin: 0 0 20px 0;\n  color: #1a1a1a;\n  font-size: 18px;\n  font-weight: 600;\n  letter-spacing: -0.3px;\n  padding-bottom: 12px;\n  border-bottom: 2px solid #f0f0f0;\n}\n\n.collection-item {\n  width: 100%;\n  padding: 14px;\n  margin-bottom: 12px;\n  background: #fafafa;\n  border: 1px solid #e8e8e8;\n  border-radius: 8px;\n  cursor: pointer;\n  text-align: left;\n  transition: all 0.2s ease;\n}\n\n.collection-item:hover {\n  background: #f0f0f0;\n  border-color: #d0d0d0;\n  transform: translateX(2px);\n  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.06);\n}\n\n.collection-item.active {\n  background: #1976d2;\n  color: white;\n  border-color: #1976d2;\n  box-shadow: 0 2px 8px rgba(25, 118, 210, 0.3);\n  transform: translateX(2px);\n}\n\n.collection-name {\n  font-weight: 600;\n  margin-bottom: 5px;\n}\n\n.collection-stats {\n  font-size: 12px;\n  display: flex;\n  gap: 12px;\n  margin-top: 6px;\n  flex-wrap: wrap;\n}\n\n.collection-item.active .collection-stats {\n  opacity: 0.9;\n}\n\n.documents-content {\n  background: white;\n  padding: 32px;\n  border-radius: 12px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);\n  min-height: 500px;\n  display: flex;\n  flex-direction: column;\n}\n\n.documents-content h3 {\n  margin: 0 0 24px 0;\n  color: #1a1a1a;\n  font-size: 20px;\n  font-weight: 600;\n  letter-spacing: -0.3px;\n}\n\n.collection-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  margin-bottom: 28px;\n  flex-wrap: wrap;\n  gap: 16px;\n  padding-bottom: 20px;\n  border-bottom: 2px solid #f0f0f0;\n  width: 100%;\n}\n\n.collection-header-actions {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  flex-wrap: wrap;\n}\n\n.collection-header h3 {\n  flex: 1;\n  min-width: 200px;\n}\n\n.collection-header-actions {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  flex-wrap: wrap;\n}\n\n.collection-details {\n  display: flex;\n  gap: 20px;\n  font-size: 13px;\n  color: #666;\n  flex-wrap: wrap;\n}\n\n.collection-details span {\n  padding: 6px 12px;\n  background: #f8f9fa;\n  border-radius: 6px;\n  font-weight: 500;\n  color: #495057;\n}\n\n.search-section {\n  margin-bottom: 28px;\n}\n\n.search-box {\n  display: flex;\n  gap: 10px;\n  align-items: center;\n}\n\n.search-box input {\n  flex: 1;\n  padding: 12px 16px;\n  border: 2px solid #e0e0e0;\n  border-radius: 8px;\n  font-size: 14px;\n  transition: all 0.2s ease;\n}\n\n.search-box input:focus {\n  outline: none;\n  border-color: #1976d2;\n  box-shadow: 0 0 0 3px rgba(25, 118, 210, 0.1);\n}\n\n.search-button,\n.clear-search-button,\n.cancel-search-button {\n  padding: 12px 24px;\n  border: none;\n  border-radius: 8px;\n  cursor: pointer;\n  font-size: 14px;\n  font-weight: 500;\n  transition: all 0.2s ease;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n\n.search-button {\n  background: #1976d2;\n  color: white;\n}\n\n.search-button:hover:not(:disabled) {\n  background: #1565c0;\n}\n\n.search-button:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.clear-search-button {\n  background: #f5f5f5;\n  color: #333;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n}\n\n.clear-search-button:hover {\n  background: #e8e8e8;\n  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15);\n}\n\n.cancel-search-button {\n  background: #ff9800;\n  color: white;\n  box-shadow: 0 2px 4px rgba(255, 152, 0, 0.3);\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.cancel-search-button:hover {\n  background: #f57c00;\n  box-shadow: 0 3px 6px rgba(255, 152, 0, 0.4);\n  transform: translateY(-1px);\n}\n\n.cancel-search-button:active {\n  transform: translateY(0);\n}\n\n.search-loading-spinner {\n  width: 14px;\n  height: 14px;\n  border: 2px solid rgba(255, 255, 255, 0.3);\n  border-top-color: white;\n  border-radius: 50%;\n  animation: spin 0.8s linear infinite;\n}\n\n@keyframes spin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.search-results {\n  margin-top: 20px;\n  flex: 1;\n}\n\n.search-results h4 {\n  margin: 0 0 20px 0;\n  color: #1a1a1a;\n  font-size: 18px;\n  font-weight: 600;\n  padding-bottom: 12px;\n  border-bottom: 2px solid #f0f0f0;\n}\n\n.search-results-list {\n  display: flex;\n  flex-direction: column;\n  gap: 15px;\n}\n\n.search-result-item {\n  padding: 18px;\n  background: #fafafa;\n  border-radius: 10px;\n  border: 1px solid #e8e8e8;\n  transition: all 0.2s ease;\n}\n\n.search-result-item:hover {\n  background: #f5f5f5;\n  border-color: #d0d0d0;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);\n}\n\n.result-score {\n  font-size: 12px;\n  color: #666;\n  margin-bottom: 8px;\n  font-weight: 600;\n}\n\n.keyword-boost-indicator {\n  color: #4caf50;\n  font-weight: normal;\n}\n\n.result-text {\n  font-size: 14px;\n  color: #333;\n  margin-bottom: 10px;\n  line-height: 1.6;\n}\n\n.result-metadata {\n  display: flex;\n  gap: 8px;\n  flex-wrap: wrap;\n}\n\n.metadata-tag {\n  padding: 4px 8px;\n  background: #e3f2fd;\n  color: #1976d2;\n  border-radius: 12px;\n  font-size: 11px;\n}\n\n.no-results {\n  text-align: center;\n  padding: 60px 40px;\n  color: #999;\n  background: #fafafa;\n  border-radius: 10px;\n  border: 2px dashed #e0e0e0;\n  font-size: 15px;\n}\n\n.documents-list {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  flex: 1;\n}\n\n.document-item {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  padding: 20px;\n  background: #fafafa;\n  border-radius: 10px;\n  border: 1px solid #e8e8e8;\n  transition: all 0.2s ease;\n}\n\n.document-item:hover {\n  background: #f5f5f5;\n  border-color: #d0d0d0;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);\n  transform: translateY(-1px);\n}\n\n.document-info {\n  flex: 1;\n}\n\n.document-title {\n  font-size: 17px;\n  font-weight: 600;\n  color: #1a1a1a;\n  margin-bottom: 10px;\n  line-height: 1.4;\n}\n\n.document-meta {\n  display: flex;\n  gap: 16px;\n  font-size: 13px;\n  color: #666;\n  margin-bottom: 10px;\n  flex-wrap: wrap;\n}\n\n.document-meta span {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n}\n\n.document-description {\n  font-size: 14px;\n  color: #666;\n  margin-bottom: 8px;\n}\n\n.document-tags {\n  display: flex;\n  gap: 8px;\n  flex-wrap: wrap;\n}\n\n.tag {\n  padding: 4px 8px;\n  background: #1976d2;\n  color: white;\n  border-radius: 12px;\n  font-size: 11px;\n}\n\n.document-actions {\n  display: flex;\n  gap: 10px;\n  flex-shrink: 0;\n  margin-left: 16px;\n}\n\n.preview-button {\n  padding: 10px 18px;\n  background: #1976d2;\n  color: white;\n  border: none;\n  border-radius: 6px;\n  cursor: pointer;\n  font-size: 13px;\n  font-weight: 500;\n  transition: all 0.2s ease;\n  box-shadow: 0 2px 4px rgba(25, 118, 210, 0.2);\n}\n\n.preview-button:hover {\n  background: #1565c0;\n  box-shadow: 0 3px 6px rgba(25, 118, 210, 0.3);\n  transform: translateY(-1px);\n}\n\n.delete-button {\n  padding: 10px 18px;\n  background: #f44336;\n  color: white;\n  border: none;\n  border-radius: 6px;\n  cursor: pointer;\n  font-size: 13px;\n  font-weight: 500;\n  transition: all 0.2s ease;\n  box-shadow: 0 2px 4px rgba(244, 67, 54, 0.2);\n}\n\n.delete-button:hover {\n  background: #d32f2f;\n  box-shadow: 0 3px 6px rgba(244, 67, 54, 0.3);\n  transform: translateY(-1px);\n}\n\n\n.preview-modal {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.5);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1000;\n}\n\n.preview-modal-content {\n  background: white;\n  padding: 0;\n  border-radius: 12px;\n  max-width: 900px;\n  width: 90%;\n  max-height: 90vh;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.2);\n}\n\n.preview-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 24px 30px;\n  border-bottom: 2px solid #f0f0f0;\n  background: #fafafa;\n}\n\n.preview-header h3 {\n  margin: 0;\n  color: #1a1a1a;\n  font-size: 20px;\n  font-weight: 600;\n  letter-spacing: -0.3px;\n}\n\n.close-button {\n  background: transparent;\n  border: none;\n  font-size: 28px;\n  cursor: pointer;\n  color: #666;\n  line-height: 1;\n  padding: 4px;\n  width: 32px;\n  height: 32px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 4px;\n  transition: all 0.2s;\n}\n\n.close-button:hover {\n  background: #f0f0f0;\n  color: #333;\n}\n\n.preview-body {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n  padding: 30px;\n  overflow-y: auto;\n  flex: 1;\n}\n\n.preview-description,\n.preview-tags {\n  font-size: 14px;\n  color: #666;\n  padding: 12px;\n  background: #f8f9fa;\n  border-radius: 6px;\n  border-left: 3px solid #1976d2;\n}\n\n.preview-text {\n  margin-top: 10px;\n}\n\n.preview-text strong {\n  display: block;\n  margin-bottom: 12px;\n  color: #1a1a1a;\n  font-size: 15px;\n  font-weight: 600;\n}\n\n.preview-text pre {\n  background: #f8f9fa;\n  padding: 20px;\n  border-radius: 8px;\n  overflow-x: auto;\n  white-space: pre-wrap;\n  word-wrap: break-word;\n  max-height: 500px;\n  overflow-y: auto;\n  font-size: 13px;\n  line-height: 1.7;\n  border: 1px solid #e8e8e8;\n  font-family: 'Consolas', 'Monaco', 'Courier New', monospace;\n}\n\n.preview-note {\n  margin-top: 10px;\n  font-size: 12px;\n  color: #999;\n  font-style: italic;\n}\n\n.loading,\n.no-documents {\n  text-align: center;\n  padding: 60px 40px;\n  color: #666;\n  font-size: 15px;\n  flex: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.no-documents {\n  background: #fafafa;\n  border-radius: 10px;\n  border: 2px dashed #e0e0e0;\n  color: #999;\n}\n\n@media (max-width: 768px) {\n  .collection-browser {\n    grid-template-columns: 1fr;\n  }\n  \n  .collections-sidebar {\n    order: 2;\n  }\n  \n  .documents-content {\n    order: 1;\n  }\n  \n  .collection-header {\n    flex-direction: column;\n    align-items: flex-start;\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
